import { api } from '@/modules/apiv2';

export default {
  state: {
    backendConfig: null,
    proxyConfigThumbprint: '',
  },

  getters: {
    backendConfig(state) {
      return state.backendConfig;
    },
    proxyConfigThumbprint(state) {
      return state.proxyConfigThumbprint;
    },
  },

  mutations: {
    setBackendConfig(state, backendConfig) {
      state.backendConfig = backendConfig;
    },
    setProxyConfigThumbprint(state, proxyConfigThumbprint) {
      state.proxyConfigThumbprint = proxyConfigThumbprint;
    },
  },

  actions: {
    getBackendConfig({ commit, getters }, template = null) {
      let endpoint = getters.backendSubscriberEndpoint;

      if (template) {
        endpoint = `${endpoint}s/${template}`;
      }

      return api
        .get(endpoint)
        .then((data) => {
          commit('setBackendConfig', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },

    getProxyThumbprint({ commit, getters }) {
      const endpoint = getters.proxyEndpoint;

      return api
        .get(endpoint)
        .then((data) => {
          commit('setProxyConfigThumbprint', data.Thumbprint);
          return data;
        })
        .catch((error) => {
          commit('setProxyConfigThumbprint', '');
          throw error;
        });
    },

    deleteProxyConfig({ commit, getters }) {
      const endpoint = getters.proxyEndpoint;

      return api
        .delete(endpoint)
        .then((response) => {
          commit('setProxyConfigThumbprint', '');
          return response;
        })
        .catch((error) => {
          throw error;
        });
    },

    upsertProxyConfig({ commit, getters }, filePassword) {
      const endpoint = getters.proxyEndpoint;

      return api.postFile(`${endpoint}?password=${filePassword}`).then((response) => {
        commit('setProxyConfigThumbprint', '');
        return response;
      });
    },

    updateBackendConfig({ commit, getters }, data) {
      const endpoint = getters.backendSubscriberEndpoint;

      return api
        .post(endpoint, data)
        .then((data) => {
          commit('setBackendConfig', data);
          return data;
        })
        .catch((error) => {
          throw error;
        });
    },
  },
};
